/**
 * Lesson videos (YouTube) and file/link attachments — shared by reader and editors.
 */

export const getYouTubeEmbedUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  try {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.trim().match(regExp);
    if (match && match[2].length === 11) {
      return `https://www.youtube.com/embed/${match[2]}`;
    }
    return null;
  } catch {
    return null;
  }
};

const trimString = (s) => String(s || '').trim();

/** Unique ordered YouTube / video page URLs from legacy `videoUrl` + `lessonVideos`. */
export const normalizeLessonVideos = (lesson) => {
  const raw = [];
  const videoList = Array.isArray(lesson?.lessonVideos)
    ? lesson.lessonVideos
    : lesson?.lessonVideos && typeof lesson.lessonVideos === 'object'
      ? Object.values(lesson.lessonVideos)
      : [];
  videoList.forEach((u) => {
    const t = trimString(u);
    if (t) raw.push(t);
  });
  const legacy = trimString(lesson?.videoUrl);
  if (legacy && !raw.includes(legacy)) raw.unshift(legacy);
  const seen = new Set();
  return raw.filter((u) => {
    const k = u.toLowerCase();
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
};

/** Normalize attachment objects for display. */
export const normalizeLessonAttachments = (lesson) => {
  if (!Array.isArray(lesson?.attachments)) return [];
  return lesson.attachments
    .map((a, i) => {
      const url = trimString(a?.url);
      if (!url) return null;
      return {
        id: trimString(a?.id) || `att-${i}`,
        title: trimString(a?.title) || 'Document',
        url,
        kind: a?.kind === 'link' ? 'link' : 'file',
      };
    })
    .filter(Boolean);
};
